import type { ApprovalStatus, FollowUpStatus, TrainingEnrollmentStatus } from '@lms/shared'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

const enrollmentStatusConfig: Record<
  TrainingEnrollmentStatus,
  { label: string; className: string }
> = {
  applied: { label: '申込済', className: 'bg-blue-100 text-blue-800 border-blue-200' },
  pending_approval: {
    label: '承認待ち',
    className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  },
  confirmed: { label: '確定', className: 'bg-green-100 text-green-800 border-green-200' },
  in_progress: { label: '受講中', className: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  completed: { label: '完了', className: 'bg-indigo-100 text-indigo-800 border-indigo-200' },
  in_follow_up: {
    label: 'フォロー中',
    className: 'bg-purple-100 text-purple-800 border-purple-200',
  },
  closed: { label: 'クローズ', className: 'bg-gray-100 text-gray-800 border-gray-200' },
  rejected: { label: '却下', className: 'bg-red-100 text-red-800 border-red-200' },
  cancelled: { label: 'キャンセル', className: 'bg-gray-100 text-gray-500 border-gray-200' },
}

const approvalStatusConfig: Record<ApprovalStatus, { label: string; className: string }> = {
  pending: { label: '承認待ち', className: 'bg-yellow-100 text-yellow-800 border-yellow-200' },
  approved: { label: '承認済', className: 'bg-green-100 text-green-800 border-green-200' },
  rejected: { label: '却下', className: 'bg-red-100 text-red-800 border-red-200' },
  proxy_approved: {
    label: '代理承認',
    className: 'bg-teal-100 text-teal-800 border-teal-200',
  },
}

const followUpStatusConfig: Record<FollowUpStatus, { label: string; className: string }> = {
  pending: { label: '本人評価待ち', className: 'bg-gray-100 text-gray-600 border-gray-200' },
  self_submitted: {
    label: '上司評価待ち',
    className: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  completed: { label: '完了', className: 'bg-green-100 text-green-800 border-green-200' },
}

interface StatusBadgeProps {
  type: 'enrollment' | 'approval' | 'followUp'
  status: string
  className?: string
}

export function StatusBadge({ type, status, className }: StatusBadgeProps) {
  let config: { label: string; className: string } | undefined

  if (type === 'enrollment') {
    config = enrollmentStatusConfig[status as TrainingEnrollmentStatus]
  } else if (type === 'approval') {
    config = approvalStatusConfig[status as ApprovalStatus]
  } else {
    config = followUpStatusConfig[status as FollowUpStatus]
  }

  if (!config) {
    return <Badge variant="outline">{status}</Badge>
  }

  return (
    <Badge variant="outline" className={cn(config.className, className)}>
      {config.label}
    </Badge>
  )
}
